/**
 * Validates password strength to match Cognito user pool policy (client-side check before submit).
 * @param {string} password
 * @returns {{ isValid: boolean, errors: string[] }}
 */
export function validatePassword(password) {
    const errors = [];

    if (!password) {
        errors.push("Password is required");
        return { isValid: false, errors };
    }

    if (password.length < 8) {
        errors.push("Password must be at least 8 characters long");
    }

    if (password.length > 128) {
        errors.push("Password must be no more than 128 characters long");
    }

    if (!/[A-Z]/.test(password)) {
        errors.push("Password must contain at least one uppercase letter");
    }

    if (!/[a-z]/.test(password)) {
        errors.push("Password must contain at least one lowercase letter");
    }

    if (!/[0-9]/.test(password)) {
        errors.push("Password must contain at least one number");
    }

    if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) {
        errors.push("Password must contain at least one special character");
    }

    return {
        isValid: errors.length === 0,
        errors
    };
}
